import { useEffect, useState } from 'react'

const useSessionStorage = <T>(
  key: string,
  initialValue: T
): [T, (value: T) => void] => {
  const [value, setValue] = useState<T>(() => {
    const storedValue = sessionStorage.getItem(key)
    return storedValue && storedValue !== 'undefined'
      ? JSON.parse(storedValue)
      : initialValue
  })

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(value))
  }, [key, value])

  return [value, setValue]
}

export default useSessionStorage
